import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFFullyCharge from '@/components/UI/svg/river2/Icon/EFFullyCharge';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/river2/pc/');
export default function E() {
    const { useEffect, useLang, useRef, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const river2_E_videoRef = useRef();
    const { locale } = useRouter();

    let controller: any;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_E .textBox',
            triggerHook: 1,
            offset: 0,
            duration: 200,
        })
            .setTween(TweenMax.to('.river2_detials_E .textBox .desc', 0.5, { top: 0 }))
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_E .img-wrapper',
            triggerHook: 1,
        })
            .on('enter', () => {
                river2_E_videoRef?.current?.current?.currentTime === 0;
            })
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_E .img-wrapper',
            triggerHook: 1,
            offset: 200,
        })
            .on('enter', () => {
                river2_E_videoRef?.current?.play();
            })
            .addTo(controller);
    }, []);

    return (
        <div className={`${css.E_5} river2_detials_E`}>
            <div className="img-wrapper-a">
                <EFPic
                    name={['e_bg_1.webp', 'e_bg_1.png']}
                    className="fullImgs"
                    alt={t('river2.details.sec3_title')}
                    aria-label={t('river2.details.sec3_title')}
                />
            </div>
            <div className={!['kr', 'tw', 'cis', 'sa'].includes(locale) ? `text-wrapper-content` : ''}>
                <div className="text-wrapper">
                    <div className="text-wrapper-ms">
                        <div className="upper-title">{t('river2.details.sec5_upper_title')}</div>
                        <div className="title">{t('river2.details.sec5_title')}</div>
                        <div className="progress-box">
                            <div className="river2">
                                <div className="bar">
                                    <span className="bar-color">
                                        <span className="bar-left">{t('river2.details.sec5_river2_name')}</span>
                                        <span className="bar-right">{t('river2.details.sec5_river2_time')}</span>
                                    </span>
                                    <span className="big-text">{t('river2.details.sec5_river2_big_text')}</span>
                                </div>
                                <div className="bar-text">{t('river2.details.sec5_river2_charge')}</div>
                            </div>
                            <div className="other">
                                <div className="bar">
                                    <span className="bar-color">
                                        <span className="bar-left">{t('river2.details.sec5_other_name')}</span>
                                        <span className="bar-right">{t('river2.details.sec5_other_time')}</span>
                                    </span>
                                </div>
                                <div className="bar-text">{t('river2.details.sec5_other_charge')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="img-wrapper">
                        <EFVideo
                            ref={river2_E_videoRef}
                            sources={['/video/river2/details/Fastest.webm', '/video/river2/details/Fastest.mp4']}
                            width="100%"
                            height="100%"
                            className="fullImgs"
                            loop={false}
                        />
                        <div className="img-text">
                            <div className="itemIcon itemIcon1" key={'itemIcon1'}>
                                <EFFullyCharge width="54px" height="54px" />
                                <div className="text">{t('river2.details.sec5_fully_charge')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="textBox">
                <div className="desc">
                    {t.rich('river2.details.sec5_desc', {
                        line1: (text1: any) => <span className="text1">{text1}</span>,
                        line2: (text2: any) => <span className="text2">{text2}</span>,
                    })}
                </div>
            </div>
        </div>
    );
}
